module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921131151_T.a6d8c389.jpg";